import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { Location } from '@angular/common';
@Component({
    selector: 'cms-partial-category-top-logos',
    templateUrl: './logos.component.html',
    styleUrls: ['./logos.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule],
})
export class LogosComponent extends CmsPartialComponentClass implements OnInit {
    @Input() logosRow: any;
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
    ngOnInit(): void {
        // console.log(this.logosRow.logos.logos[0].background_color);
    }
}
